"use strict";
export default (() => {
  var _a;
  const BootstrapPopover = ((_a = window.bootstrap) == null ? void 0 : _a.Popover) || Popover;
  const popoverTriggerList = document.querySelectorAll(
    '[data-bs-toggle="popover"]'
  );
  const popoverList = [...popoverTriggerList].map(
    (popoverTriggerEl) => new bootstrap.Popover(popoverTriggerEl)
  );
})();
